import { Component, computed, inject, OnInit, Signal, signal, viewChild } from '@angular/core';
import { form, submit } from '@angular/forms/signals';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { ProjectBasicInformationComponent } from '@app/components/company/company-projects/company-project-basic-information/project-basic-information.component';
import { projectFormSchema } from '@app/components/company/company-projects/create-project-dialog/create-project-form-controls';
import { EditProjectModel } from '@app/components/company/company-projects/edit-project-dialog/edit-project-form-controls';
import { EditProjectService } from '@app/components/company/company-projects/edit-project-dialog/edit-project.service';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';

import { ProjectEditDialogData } from '@app/shared/types/models/project/project.model';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'proffeo-edit-project-dialog',
  imports: [
    MatDialogModule,
    TranslatePipe,
    UiDialogComponent,
    MatStepperModule,
    ProjectBasicInformationComponent,
    UiButtonComponent
  ],
  templateUrl: './edit-project-dialog.component.html',
  styleUrl: './edit-project-dialog.component.scss',
  providers: [EditProjectService]
})
export class EditProjectDialogComponent implements OnInit {
  private readonly dialogData: ProjectEditDialogData = inject(MAT_DIALOG_DATA);
  private readonly editProjectService: EditProjectService = inject(EditProjectService);
  private readonly dialogRef: MatDialogRef<EditProjectDialogComponent> = inject(
    MatDialogRef<EditProjectDialogComponent>
  );

  protected readonly stepper: Signal<MatStepper> = viewChild<MatStepper>('stepper');

  protected readonly isLastStep: Signal<boolean> = computed(
    () => this.stepper().selectedIndex === this.stepper().steps.length - 1
  );
  protected readonly model = signal<EditProjectModel>(
    this.editProjectService.createInitialModel(this.dialogData.projectToEdit)
  );
  protected readonly form = form(this.model, projectFormSchema);

  protected close(): void {
    this.dialogRef.close();
  }

  protected saveProject(): void {
    void submit(this.form, {
      action: async () => {
        await firstValueFrom(
          this.editProjectService.saveProject(this.model(), this.dialogData.projectToEdit, this.dialogData.isDraftList)
        );
        this.close();
      }
    });
  }

  public ngOnInit(): void {
    this.editProjectService.initProjectData(this.dialogData.projectToEdit.id);
  }
}
